import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Crop } from 'react-image-crop';
import styled from '@emotion/styled';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { availableImageFormats } from '@myme/utils';
import { SvgIcon } from 'src/components/atoms';
import { ResizeUserAvatarDialog } from './ResizeUserAvatarDialog';
import { useDialog } from '../organisms';

interface UserAvatarUpload {
  name: string;
  data: string;
}

const StyledLabel = styled.label`
  display: none;
  transition: all 1s;
`;

const CameraOverlayButton = styled(SvgIcon)`
  position: absolute;
  cursor: pointer;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 4rem;
  width: 4rem;
  transition: all 1s;
`;

export const UploadAvatarField = () => {
  const [previewImage, setPreviewImage] = useState<UserAvatarUpload | null>();
  const [completedCrop, setCompletedCrop] = useState<Crop | null>(null);
  const { isOpen, openDialog, closeDialog } = useDialog();
  const inputRef = useRef<HTMLInputElement>() as React.MutableRefObject<HTMLInputElement>;

  useEffect(() => {
    if (previewImage) {
      openDialog();
    }
  }, [previewImage]);

  const handleSelectFile = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length === 1) {
      const avatarName = e.target.files[0].name;

      const reader = new FileReader();
      reader.addEventListener('load', () => {
        if (reader.result) {
          setPreviewImage({ name: avatarName, data: reader.result.toString() });
        }
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleImageResizeCancel = () => {
    closeDialog();
    setPreviewImage(null);
    setCompletedCrop(null);

    inputRef.current.value = '';
  };

  return (
    <>
      <StyledLabel htmlFor='user-img'>
        <CameraOverlayButton>
          <PhotoCameraIcon />
        </CameraOverlayButton>
        <input
          id='user-img'
          type='file'
          accept={availableImageFormats}
          onChange={handleSelectFile}
          // Reset input value to have an option of choosing the same file again
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onClick={(e: any) => {
            e.target.value = '';
          }}
          style={{ display: 'none' }}
        />
      </StyledLabel>
      {previewImage && (
        <ResizeUserAvatarDialog
          open={isOpen}
          previewImage={previewImage}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          onClose={closeDialog}
          onCancelClose={handleImageResizeCancel}
        />
      )}
    </>
  );
};
